<ngx-spinner template="<img src='assets/images/spinner.gif'/>"></ngx-spinner>
<div class="order-processing-content" dir="{{languageDir}}">
  <div class="content-top-box ">
    <ul class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
        <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
          (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
      </li>
    </ul>
    <div class="top-box-content">
      <h1 class="main-title">{{langObj ? langObj?.BatchInputReport : ('BatchInputReport' | translate)}}</h1>
    </div>
  </div>

  <form [formGroup]="batchForm">
    <div class="wrapper-box wrapper-box-shadow table-wrapper">
      <!-- <div class="content-top-box-content">
        <h1 class="content-title">Process Order</h1>
      </div> -->
      <div class="content-top-row content-top-row-order-processing" *ngIf="Isexpandcontenthide">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="queryCriteria" (selectionChange)="criteriaChange($event)"
            placeholder="{{langObj ? langObj?.QueryCriteria : ('Query Criteria' | translate)}}" panelClass="testClass" name="Status">
            <mat-option value="lastshift">{{langObj ? langObj?.LastShift : ('LastShift' | translate)}}</mat-option>
            <mat-option value="yesterday">{{langObj ? langObj?.Yesterday : ('Yesterday' | translate)}}</mat-option>
            <mat-option value="today" selected>{{langObj ? langObj?.Today : ('Today' | translate)}}</mat-option>
            <mat-option value="custom">{{langObj ? langObj?.Custom : ('Custom' | translate)}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="inputField">
          <nz-date-picker  class="calender-input" [nzDisabled]="disabled" id="startPicker" formControlName="startDate" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }"  [nzInputReadOnly]="true" ></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>   
        </div>
        <div class="inputField">
          <nz-date-picker  class="calender-input" [nzDisabled]="disabled"  id="endPicker" formControlName="endDate" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }"  [nzInputReadOnly]="true" ></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>   
        </div>
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing" *ngIf="length">
          <mat-select formControlName="UserGroup1" (selectionChange)="getPlants($event)" placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}"
            panelClass="testClass" name="Status">
            <mat-option *ngFor="let group of GroupList" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing" *ngIf="length">
          <mat-select formControlName="UserPlant1" placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="plant" (selectionChange)="getItemCode()">
            <mat-option *ngFor="let plant of PlantList1" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                <mat-select formControlName="shift"  placeholder="{{langObj ? langObj?.Shift : ('Shift' | translate)}}" 
                    panelClass="testClass" name="Status">
                    <mat-option  value="all">{{langObj ? langObj?.ALL : ('ALL' | translate)}}</mat-option>
                    <mat-option  value="day">{{langObj ? langObj?.Day : ('Day' | translate)}}</mat-option>
                    <mat-option  value="night">{{langObj ? langObj?.Night : ('Night' | translate)}}</mat-option>
                </mat-select>
            </mat-form-field>

      </div>
      <div class="content-top-row content-top-row-order-processing" *ngIf="Isexpandcontenthide">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="ItemCode" (selectionChange)="onItemCodeChange($event)" placeholder="{{langObj ? langObj?.ItemCode : ('Item Code' | translate)}}"
            panelClass="testClass" name="itemCode">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'ItemCode'" [array]="itemList"
            (filteredReturn)="filteredItemCodes = $event"></mat-select-filter>
            <mat-option *ngFor="let item of filteredItemCodes" [value]="item.ItemCode" matTooltipClass="custom-tooltip" matTooltip="{{item.ItemDesc}}" matTooltipposition="right">
              {{item.ItemCode}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="line" placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
            <mat-option *ngFor="let line of lineList" [value]="line.PL_Id">
              {{line.PL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}" panelClass="testClass" name="unit">
            <mat-option *ngFor="let unit of unitList" [value]="unit.PU_Id">
              {{unit.PU_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="po" placeholder="{{langObj ? langObj?.ProcessOrder : ('Process Order' | translate)}}" (selectionChange)="onPOChange($event)"
            panelClass="testClass" name="po">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="processOrderList"
            (filteredReturn)="filteredPOs = $event"></mat-select-filter>
            <mat-option value="0">{{langObj ? langObj?.ALL : ('ALL' | translate)}}</mat-option>
            <mat-option *ngFor="let po of filteredPOs" [value]="po.TypeName">
              {{po.TypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="batchType" placeholder="{{langObj ? langObj?.BatchType : ('Batch Type' | translate)}}" panelClass="testClass" name="Status">
            <mat-option value="0">{{langObj ? langObj?.ALL : ('ALL' | translate)}}</mat-option>
            <mat-option value="1">{{langObj ? langObj?.Rework : ('Rework' | translate)}}</mat-option>
            <mat-option value="2">{{langObj ? langObj?.Normal : ('Normal' | translate)}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="btn-position btn-position-order-processing">
          <button mat-flat-button color="accent" class="btn-accent" (click)="onSubmit()">{{langObj ? langObj?.ApplyFilter : ('ApplyFilter' | translate)}}</button>
        </div>
      </div>
      <div class="menu-card-group" *ngIf="Isexpandcontenthide">
        <div class="menu-card-item">
          <p class="title-text">{{langObj ? langObj?.NumberofBatches : ('NumberofBatches' | translate)}}</p>
          <p class="data-text">
            {{NB}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item">
          <p class="title-text">{{langObj ? langObj?.TotalEstimatedQuantity : ('TotalEstimatedQuantity' | translate)}}</p>
          <p class="data-text">
            {{TEQ}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item">
          <p class="title-text">{{langObj ? langObj?.TotalActualQuantity : ('TotalActualQuantity' | translate)}}</p>
          <p class="data-text">
            {{TAQ}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
      </div>
      <section>
        <div class="example-button-row">
          <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 25px;"><img src="assets/images/csv-file-format.png" ></button>
          <button type="button" class="btn btn-success" (click)="excelExport()" style="margin-top: 25px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"  aria-hidden="true"></i></button>
          <button *ngIf="Isexpandcontenthide" mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Expand Grid" tooltipPosition="top"
          (click)="expand()" style="float: right; margin-top: 20px;">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Collapse Grid" tooltipPosition="top" (click)="close()" *ngIf="Isexpandcontentbuttonshow"  style="float: right; margin-top: 20px;">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
        </div>
      </section>
        <mat-card-content>
          <!-- <ag-grid-angular style="width: 100%; height: 24vw;margin-top: 10px;" class="ag-theme-alpine" [rowData]="rowData"
            [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"  [frameworkComponents]="frameworkComponents"
             [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="50">
          </ag-grid-angular> -->
          <ag-grid-angular #agGrid style="width: 100%; height: 40vw" id="myGrid" class="ag-theme-alpine"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [masterDetail]="true" [defaultExportParams]="defaultExportParams"  [excelStyles]="excelStyles"
          [detailCellRendererParams]="detailCellRendererParams" [rowData]="rowData"  [animateRows]="true"
          (firstDataRendered)="onFirstDataRendered($event)" (gridReady)="onGridReady($event)"  [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="50">
      </ag-grid-angular>
        </mat-card-content>    
      
    </div>
  </form>
</div>
<ng-template #batchViewModal>
  <div class="viewChecklist">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{langObj ? langObj?.BatchHistoryView : ('BatchHistoryView' | translate)}}</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div class="content-row-flex-both-end">
      <!--table-->
      <table mat-table class="basic-table plant-model-table" [dataSource]="batchReportViewDatasource" matSort>
        <!-- Item Type Column -->
        <ng-container matColumnDef="itemtype">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Item : ('Item' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemCode}}</td>
        </ng-container>

        <ng-container matColumnDef="itemDesc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.ItemDescription : ('ItemDescription' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemDesc}}</td>
        </ng-container>
        <ng-container matColumnDef="itemuom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.ItemUOM : ('ItemUOM' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.UOM}}</td>
        </ng-container>

        <!-- Batch Column -->
        <ng-container matColumnDef="estQty">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.EstimatedQty : ('EstimatedQty' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.EsimatedQty}}</td>
        </ng-container>

        <!-- length Column -->
        <ng-container matColumnDef="actQty">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text"> {{langObj ? langObj?.BatchInputReport : ('BatchInputReport' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemBOMValue}}</td>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Supplier : ('Supplier' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.Supplier}}</td>
        </ng-container>
        <ng-container matColumnDef="prodDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Productiondate : ('Productiondate' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ProductionDate}}</td>
        </ng-container>
        <ng-container matColumnDef="expireDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Expiredate : ('Expiredate' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ExpireDate}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="batchViewColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: batchViewColumns"></tr>
        <tr class="mat-row" *matNoDataRow style="text-align: center;">
          <td class="mat-cell" colspan="8">{{langObj ? langObj?.nodatafound : ('nodatafound' | translate)}}</td>
        </tr>
      </table>
    </div>
  </div>
</ng-template>